import script from "./LoginForgetCompleteView.vue?vue&type=script&lang=ts&setup=true"
export * from "./LoginForgetCompleteView.vue?vue&type=script&lang=ts&setup=true"

import "./LoginForgetCompleteView.vue?vue&type=style&index=0&id=59e896a9&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/jobs/MASSMEDIAN_MYPAGE_VIEW_PROD/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-59e896a9"]])

export default __exports__